import React from 'react';
import { FlightContext } from '.';

export const useFlightProvider = () => {
  const { 
    status,
    battery, 
    flightData,
    flightDataByMissionId,
    flightMode, 
    velocityNed, 
    attitudeEuler, 
    distanceSensor, 
    gpsInfo,
    vhrNud,
  } = React.useContext(FlightContext);

  return {
    status,
    battery,
    flightMode,
    flightDataByMissionId,
    velocityNed,
    attitudeEuler,
    distanceSensor,
    gpsInfo,
    vhrNud,
    flightData,
  };
};